import { computed, makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

export class StudentWorkbookPage extends DTO {
  progressId: number
  status: common.StudentScoringStatus
  readonly openDatetime?: Date
  readonly workbookPage: {
    id: number
    workbookId: number
    page: number
    title: string
    imageUrl?: string
  }

  get pageNum() {
    return this.workbookPage.page
  }

  constructor(data: res.StudentWorkbookProgress) {
    super()
    this.progressId = data.progressId
    this.status = data.status
    this.workbookPage = data.workbookPage
    this.openDatetime = data.openDateTime ? new Date(data.openDateTime) : undefined

    makeObservable(this, { status: observable, pageId: computed, pageNum: computed })
  }

  get pageId() {
    return this.workbookPage.id
  }
}
